module.exports = function() {
  return new Worker(__webpack_public_path__ + "56d06f1156641fdcb8d6.worker.js");
};